import React, { useCallback, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router";
import { getItemOfSessionStorage } from "../../services/common/utils";
import { SELECTED_LANG } from "../../services/common/Constants";
import { useMutation, useQuery, } from "react-query";
import parse from 'html-react-parser';
import PageShimmer from "../loader/skeletons/common/page-shimmer";
import { CDR_DO_TRANS, CDR_TandC } from "../../services/common/endpoints";
import { callQueryapi } from "../../services/http/callapi";
import { useSelector, useDispatch } from "react-redux";
import { setCdrtransid } from "../../reducer/cdrSlice";
import { getCurrentMonthObject } from "../../services/common/CommonUtils";
import Loadingcomponent from "../loader/loadingcomponent";
import MessageModal from "../common/bottom-modal-message";
import { useTranslation } from 'react-i18next';

const TermsAndConditions = ({
  show,
  toggleModal,
  handleCheck,
  redirectUrl='',
  segmentId='',
  commonconfigurations={},
  confirmationverificationconfigurations={}
}) => {
  const [checked, setCheked] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customerprofile = useSelector(
    (state) => state.userdata.value.customerprofile
  );
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const { cdrData = {} } = useSelector((store) => store);
  const { cdrSettings = {}, civilID, cdrtransid, cdrPlanType, isCdrCardsData } = cdrData;
  const isFreePlan = cdrPlanType === "FREE"; //getItemOfSessionStorage('CDR') !== 'Subscribe';
  const isVipCust = ((cdrSettings?.commonconfigurations?.enable_vip_simulation === 'T' && cdrSettings?.commonconfigurations?.vip_simulator_numbers?.indexOf(msisdn) > -1) || customerprofile?.vipstatus === "Y");
  const lang = getItemOfSessionStorage(SELECTED_LANG);
  const [showMessage, setShowMessage] = useState(false);
  const [flag, setFlag] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  // close_icon + heading + message

  const ToggleFnc = useCallback(() =>{
    setFlag(!flag);
  }, [flag])

  const { mutate, data: apiRes, isLoading, isFetching } = useMutation(
    (reqObj) =>
      callQueryapi({
        queryKey: [
          {},
          CDR_DO_TRANS,
          reqObj,
          {}, false, 'cdr'
        ],
      }),
    {
      onSuccess: ({ data }) => {
        if(data?.status === '0' && data?.response){
          dispatch(setCdrtransid(data.response));
          ToggleFnc();
          navigate('/call-details');
        }else{
          setShowMessage(true);
        }
      },
    }
  );


const handleScroll = (e) =>{
  if(e.target.getBoundingClientRect().height + 20 >= e.target.scrollHeight - e.target.scrollTop ) {
    setCheked(true);
    handleCheck("checked")
  }
}
  const handleClick = () => {
    if (!checked) {
      handleCheck("checked");
    } else {
      handleCheck("not checked");
    };
    setCheked(!checked)
  }

  const handleConfirmClick = () =>{
    const currentMonth = getCurrentMonthObject();

    if(isCdrCardsData === false && cdrtransid !== '' && cdrtransid !== null && cdrtransid !== undefined){
      // ToggleFnc();
      setShowLoader(true);
      setTimeout(() => {
        navigate(`/call-details`); 
      }, 1)
    }else if(isFreePlan || isVipCust){
    // 1)
    // Vip Changes:
    // "cdrtype": "Premium",
    // =======================
    // New ==> "isvip": "T"
      mutate({
        "cdrtype": isVipCust ? "Premium" : "Free", //premium or free
        "isvip": isVipCust ? "T" : "",
        "isverified": "T", //T
        "civilid": civilID,
        // "price": "6",
        "price": "0",
        // "paymonths": [
        //   {
        //     "month": "April", //select month
        //     "monthnumber": "04", //selected month number
        //     "year": "2024" //year of the selected year
        //   },
        //   {
        //     "month": "May",
        //     "monthnumber": "05",
        //     "year": "2024"
        //   }
        // ]
        paymonths: [currentMonth]
      })
    }else{
      if(redirectUrl) { 
        ToggleFnc();
        navigate(`/${redirectUrl}`) 
      }
      else {
        toggleModal()
      }
    }
    
  }

  const [productDetails, setProductDetails] = useState('')
  const {data: {data}={}} = useQuery([{}, CDR_TandC,
  {   
    "segmentid":segmentId,
    "iseshop":"false",
    "childlineflag":"false"
  },
  {"langcookie": lang}
],
  {
    staleTime: 0,
    cacheTime: 0,
    onSuccess: ({data: udata}) =>{
      if(udata?.status !== "-1"){
        if(udata?.response){
          setProductDetails(udata?.response[0]?.ProductDetails)
        }
      }
    }
  })

  const doingTrans = (isLoading || isFetching); 

  const message = apiRes?.data?.message ? apiRes?.data?.message : t('somethingwentwrong');

  return (
    <>
    <div className="">
    <Modal
      show={flag && show}
      backdrop="true"
      onHide={toggleModal}
      className="modal bottom_modal-verify animated slideInUp faster p-0 sprint16-modal-popup sprint17tandc-modal-popup sprint17scrollbar scrollbar1"
    >
      {data ? <>
      <Modal.Header className="border-0">
        <h6 className="dir-ltrl">{productDetails?.ProductName}</h6>

        <button className="badges-close-button"
        // onClick={toggleModal}
        >
          <img
            onClick={toggleModal}
            src={process.env.PUBLIC_URL + "/assets/images/cross_dark.svg"}
            alt=""
            title=""
          />
        </button>
      </Modal.Header>
      <Modal.Body id="modal-body" onScroll={(e) => handleScroll(e)} >
        {/* <div className="sprint16-verify-popup" id="inner-popup"> */}
          {/* <div className="verify-popup-inner sprint16-form-control" > */}
          {parse(productDetails?.summary)}
          {/* </div> */}

        {/* </div> */}
      </Modal.Body>
      <div class="modal-footer">

        <div className='sprint17-tandc-footer mt-2 w-100'>
          <div className="sprint17-acce-tandc">
            <div>
              <input id="radio-tc01" class="radio-custom" name="radio-group" type="radio" checked={checked}
                onClick={handleClick} />
              <label for="radio-tc01" class="radio-custom-label">{confirmationverificationconfigurations?.popup_agreefor}
                <a> {confirmationverificationconfigurations?.button_text}</a></label>
            </div>
          </div>

          <div class="flex_grp_align_center">
            <button class="custom_btn custom_btn_primary_outline btn_block me-4 sp16_custom_btn" onClick={toggleModal}> {commonconfigurations?.cancel_btn} </button>
            <button class="custom_btn custom_btn_primary btn_block ms-4 sp16_custom_btn" disabled={!checked || doingTrans || showLoader} onClick={handleConfirmClick}> 
            {
              (isLoading || isFetching || showLoader) ? <Loadingcomponent width="25%" /> : commonconfigurations?.agree_btn
            }
             </button>
          </div>

        </div>

      </div>
      </>: <PageShimmer/>}
    </Modal>


    <MessageModal type="2" show={showMessage} message={message} handleOk={() => setShowMessage(false)} isBackdropClickAllowed={true} />
    </div>
    </>
    
  );

};
export default TermsAndConditions;
